import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ultra-orders',
  template: `
  <router-outlet></router-outlet>
  `,
})
export class OrdersComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
